export const PAYMENT_TRANSLATIONS = {
    "cs": {
        "paymentCardholderNameLabel": "Jméno: (tak, jak je uvedeno na kartě)",
        "cardholderNameError": "This field can only contain characters 0-9.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Číslo kreditní karty",
        "monthLabel": "Měsíc",
        "yearLabel": "Rok",
        "defaultpayLabel": "Nastavit jako výchozí kreditní kartu.",
        "requiredLabel": "Povinný údaj",
        "savepayLabel": "Uložte tuto kreditní kartu do mého profilu.",
        "saveAsPrimaryCardText": "Nastavit jako výchozí kreditní kartu."
    },
    "da": {
        "paymentCardholderNameLabel": "Navn: (som det er anført på kreditkortet)",
        "cardholderNameError": "Dette felt må kun indeholde romertal (IV, V, X).",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Kortnummer",
        "monthLabel": "Måned",
        "yearLabel": "År",
        "defaultpayLabel": "Gem dette kreditkort som mit standardbetalingskort.",
        "requiredLabel": "Dette felt skal udfyldes.",
        "savepayLabel": "Gem dette kreditkort i min personlige profil.",
        "saveAsPrimaryCardText": "Gem dette kreditkort som mit standardbetalingskort."
    },
    "de": {
        "paymentCardholderNameLabel": "Kontoinhaber: (wie auf der Kreditkarte angegeben)",
        "ibanAccountHolderNameLabel": "Name des Kontoinhabers",
        "ibanLabel": "IBAN",
        "cardholderNameError": "Dieses Feld akzeptiert nur die Zeichen A-Z, 0-9.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Kreditkartennummer",
        "bankCountryLabel": "Land",
        "monthLabel": "Monat",
        "yearLabel": "Jahr",
        "defaultpayLabel": "Diese Kreditkarte als Standard festlegen.",
        "requiredLabel": "Dieses Feld muss ausgefüllt werden.",
        "directDebitAgreementLabel": "Für eine neue Lastschriftzahlung benötigt Nu Skin eine unterschriebene Einzugsermächtigung, um Geld von Ihrem Konto abbuchen zu können. Sie erhalten dieses Formular im Anhang an eine E-Mail. Durch Aktivieren dieses Kästchens stimmen Sie zu, dass Ihre Bestellung erst versandt wird, nachdem Nu Skin die unterschriebene Einzugsermächtigung von Ihnen bis spätestens 14:00 Uhr am letzten Werktag des Monats zurückerhalten hat.",
        "savepayLabel": "Diese Kreditkarte in meinem persönlichen Profil speichern.",
        "saveAsPrimaryCardText": "Diese Kreditkarte als Standard festlegen.",
        "electronicMandateLabel": "Elektronisches Mandat",
        "paperMandateLabel": "Ausgedrucktes Mandat"
    },
    'en': {
        'paymentCardholderNameLabel': 'Name (as is appears on the credit card)',
        "ibanAccountHolderNameLabel": "Account Holder",
        "ibanLabel": "IBAN",
        'paymentCardholderNamePlaceholder': 'Cardholder Name',
        'cardholderNameError': 'Numbers are not allowed in this field.',
        'cardholderNameMaxlength': '30',
        'cardholderNameRegex': /^[^$*&%#@0-9]{2,30}$/,
        'ccNumberLabel': 'Credit Card Number ',
        'ccNumberPlaceholder': '0000000000000000',
        'ccNumberError': 'The card number you have entered is invalid.',
        'ccNumberMaxlength': '16',
        'ccNumberRegex': /^[0-9]{16}$/,
        "bankCountryLabel": "Country",
        'monthLabel': 'Expiration Month',
        'yearLabel': 'Expiration Year',
        'defaultpayLabel': 'Save as primary credit card.',
        "directDebitAgreementLabel": "For new direct debit payment Nu Skin needs to receive a signed form for authorisation to withdraw money from your account. This form will be sent to you attached to an e-mail. By ticking this checkbox you confirm to acknowledge that your order cannot be released for shipping unless Nu Skin receives the signed form back from you no later than 14:00h on the last business day of the month.",
        'savepayLabel': 'Save credit card to My Account',
        'requiredLabel': 'This field is required.',
        'saveAsPrimaryCardText': 'Save as primary credit card',
        "electronicMandateLabel": "Electronic Mandate",
        "paperMandateLabel": "Paper Mandate"
    },
    'es': {
        'paymentCardholderNameLabel': 'Nombre (como aparece en la tarjeta de crédito)',
        "ibanAccountHolderNameLabel": "Titular de la cuenta",
        "ibanLabel": "IBAN",
        'paymentCardholderNamePlaceholder': 'Nombre del titular de la tarjeta',
        'cardholderNameError': 'El nombre que ha ingresado no es válido.',
        'cardholderNameMaxlength': '30',
        'cardholderNameRegex': /^[^$*&%#@0-9]{2,30}$/,
        'ccNumberLabel': 'Número de tarjeta de crédito',
        'ccNumberPlaceholder': '0000000000000000',
        'ccNumberError': 'El número de tarjeta que ha ingresado no es válido.',
        'ccNumberMaxlength': '16',
        'ccNumberRegex': /^[0-9]{16}$/,
        "bankCountryLabel": "País",
        'monthLabel': 'Mes de expiración',
        'yearLabel': 'Año de caducidad',
        'yearError': 'El año que ingresó no es válido',
        'defaultpayLabel': 'Guardar como tarjeta de crédito principal.',
        'savepayLabel': 'Guardar tarjeta de crédito en Mi Cuenta',
        'requiredLabel': 'Este campo es requerido.'
    },
    "es_ES": {
        "paymentCardholderNameLabel": "Nombre Completo: (tal cual aparece en la tarjeta)",
        "monthLabel": "Mes",
        "yearLabel": "Año",
        "defaultpayLabel": "Esta es mi tarjeta de crédito por defecto.",
        "requiredLabel": "Es un campo obligatorio",
        "savepayLabel": "Guardar esta tarjeta de crédito en mi perfil personal.",
        "saveAsPrimaryCardText": "Esta es mi tarjeta de crédito por defecto."
    },
    "es_MX": {
        "paymentCardholderNameLabel": "Nombre Completo: (coma aparece en la tarjeta de crédito)"
    },
    "es_PE": {
        "paymentCardholderNameLabel": "Nombre Completo: (Como aparece en la tarjetas de crédito)",
        "defaultpayLabel": "Esta es mi tarjeta de crédito por defecto.",
        "saveAsPrimaryCardText": "Esta es mi tarjeta de crédito por defecto."
    },
    "es_US": {
        "paymentCardholderNameLabel": "Nombre Completo: (coma aparece en la tarjeta de crédito)"
    },
    "es_VE": {
        "requiredLabel": "Es una área requeria"
    },
    "fi": {
        "paymentCardholderNameLabel": "Nimi: (kuten luottokortissa ilmoitetaan)",
        "cardholderNameError": "Tämä kenttä voi sisältää ainoastaan merkkejä A-Z ja 0-9.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Luottokortin numero",
        "monthLabel": "Kuukausi",
        "yearLabel": "Vuosi",
        "defaultpayLabel": "Tee tästä luottokortista oletuskorttini.",
        "requiredLabel": "Tämä kenttä on pakollinen.",
        "savepayLabel": "Tallenna tämän luottokortin tiedot henkilökohtaisiin tietoihini",
        "saveAsPrimaryCardText": "Tee tästä luottokortista oletuskorttini."
    },
    "fr": {
        "paymentCardholderNameLabel": "Nom: (du détenteur de la carte)",
        "ibanAccountHolderNameLabel": "Titulaire du compte",
        "ibanLabel": "IBAN",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Numero de la carte de credit",
        "bankCountryLabel": "Pays",
        "monthLabel": "Mois d'expiration",
        "yearLabel": "Annee d'expiration",
        "defaultpayLabel": "Utilisez par défaut cette carte de crédit.",
        "requiredLabel": "Ceci est un champ obligatoire.",
        "savepayLabel": "Sauvegardez cette carte de credit dans Mon Profil",
        "saveAsPrimaryCardText": "Utilisez par défaut cette carte de crédit."
    },
    "fr_BE": {
        "paymentCardholderNameLabel": "Nom: (du détenteur de la carte)"
    },
    "fr_CA": {
        "ccNumberLabel": "Numero de la carte de credit",
        "savepayLabel": "Sauvegardez cette carte de credit dans Mon Profil"
    },
    "fr_NC": {
        "savepayLabel": "Sauvegardez cette carte de credit dans Mon Profil"
    },
    "fr_PF": {
        "savepayLabel": "Sauvegardez cette carte de credit dans Mon Profil"
    },
    "hu": {
        "paymentCardholderNameLabel": "Név: (ahogyan az a hitelkártyán megjelenik)",
        "cardholderNameError": "Ez a mező csak római számokat (IV, V, X) tartalmazhat.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Hitelkártya száma",
        "monthLabel": "Hónap",
        "yearLabel": "Év",
        "defaultpayLabel": "Mentés alapértelmezett bankkártyaként.",
        "requiredLabel": "E mező kitöltése kötelező.",
        "savepayLabel": "Ezen bankkártya mentése személyes profilomba!",
        "saveAsPrimaryCardText": "Mentés alapértelmezett bankkártyaként."
    },
    "in": {
        "paymentCardholderNameLabel": "Nama Lengkap: (as it appears on the credit card)",
        "cardholderNameRegex": "[A-Za-z]",
        "cardholderNameError": "Nomor tidak di perbolehkan",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Credit Card Number",
        "monthLabel": "Expiration Month",
        "yearLabel": "Expiration Year",
        "requiredLabel": "This field is required."
    },
    "is": {
        "paymentCardholderNameLabel": "Nafn: (eins og ritað er á korti)",
        "cardholderNameError": "Þessi eyða getur aðeins innihaldið rómverska bókstafi (IV, V, X).",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Kortanúmer",
        "monthLabel": "Mánuður",
        "yearLabel": "Ár",
        "defaultpayLabel": "Gera þetta sjálfkrafa að korti sem ég nota.",
        "requiredLabel": "Þessa eyðu má ekki skilja eftir auða.",
        "savepayLabel": "Geyma þetta kortanúmer í mínum skrám.",
        "saveAsPrimaryCardText": "Gera þetta sjálfkrafa að korti sem ég nota."
    },
    "it": {
        "paymentCardholderNameLabel": "Nome: (come indicato sulla carta)",
        "ibanAccountHolderNameLabel": "Titolare del conto",
        "ibanLabel": "IBAN",
        "cardholderNameError": "Questo campo può contenere solo caratteri romani (IV, V, X).",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Numero carta di credito",
        "bankCountryLabel": "Paese",
        "monthLabel": "Mese",
        "yearLabel": "Anno",
        "defaultpayLabel": "Questa è la mia carta di credito standard",
        "requiredLabel": "Questo è un campo obbligatorio.",
        "savepayLabel": "Salva questa carta di credito nel mio profilo personale.",
        "saveAsPrimaryCardText": "Questa è la mia carta di credito standard"
    },
    "it_CH": {
        "cardholderNameError": "Questo campo può contenere solo caratteri A-Z, 0-9.",
        "requiredLabel": "Questo campo è obbligatorio."
    },
    "iw": {
        "paymentCardholderNameLabel": ":שם (כפי שמופיע בכרטיס האשראי)",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": ":מספר כרטיס אשראי",
        "monthLabel": ":חודש פקיעת תוקף",
        "yearLabel": ":שנת פקיעת תוקף",
        "defaultpayLabel": "שמור ככרטיס אשראי ראשי",
        "requiredLabel": "This field is required.",
        "savepayLabel": "שמור כרטיס אשראי לפרופיל שלי",
        "saveAsPrimaryCardText": "שמור ככרטיס אשראי ראשי"
    },
    'ja': {
        "paymentCardholderNameLabel": "氏名：",
        'cardholderNameMaxlength': '30',
        'cardholderNameRegex': /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "クレジットカード番号：",
        'ccNumberMaxlength': '16',
        'ccNumberRegex': /^[0-9]{16}$/,
        "monthLabel": "有効期限月：",
        "yearLabel": "有効期限年：",
        "defaultpayLabel": "第1クレジットカードとして保存する",
        "savepayLabel": "マイ アカウントにクレジットカードを保存する",
        "requiredLabel": "この項目は必須です。",
        "saveAsPrimaryCardText": "第1クレジットカードとして保存する"
    },
    "ms": {
        "paymentCardholderNameLabel": "Nama Penuh",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Credit Card Number",
        "monthLabel": "Expiration Month",
        "yearLabel": "Expiration Year",
        "defaultpayLabel": "Save as primary credit card",
        "requiredLabel": "This field is required.",
        "savepayLabel": "Save credit card to My Account",
        "saveAsPrimaryCardText": "Save as primary credit card"
    },
    "nl": {
        "paymentCardholderNameLabel": "Naam: (zoals vermeld op de creditcard)",
        "ibanAccountHolderNameLabel": "Rekeninghouder",
        "ibanLabel": "IBAN",
        "cardholderNameError": "Dit veld mag alleen de tekens A-Z, 0-9 bevatten.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Nummer kredietkaart",
        "bankCountryLabel": "Land",
        "monthLabel": "Maand",
        "yearLabel": "Jaar",
        "defaultpayLabel": "Maak dit mijn standaardkredietkaart.",
        "requiredLabel": "Dit veld is verplicht.",
        "savepayLabel": "Sla deze kredietkaart op in mijn persoonlijke profiel.",
        "saveAsPrimaryCardText": "Maak dit mijn standaardkredietkaart."
    },
    "nl_NL": {
        "cardholderNameError": "In dit veld mogen alleen Romeinse cijfers staan (IV, V, X).",
        "requiredLabel": "Dit is een verplicht veld."
    },
    "no": {
        "paymentCardholderNameLabel": "Navn: (slik det fremgår på kredittkortet)",
        "cardholderNameError": "Dette feltet skal kun inneholde romerske tegn (IV, V, X)",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Betalingskortnummer",
        "monthLabel": "Måned",
        "yearLabel": "År",
        "defaultpayLabel": "Gjør dette til mitt standard kredittkort.",
        "requiredLabel": "Dette er et obligatorisk felt.",
        "savepayLabel": "Lagre dette kredittkortet på min personlige profil.",
        "saveAsPrimaryCardText": "Gjør dette til mitt standard kredittkort."
    },
    "pl": {
        "paymentCardholderNameLabel": "Imię i nazwisko: (jak występują na karcie kredytowej)",
        "cardholderNameError": "To pole może zawierać wyłącznie znaki arabskie (1, 2, 3).",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Numer karty kredytowej",
        "monthLabel": "Miesiac",
        "yearLabel": "Rok",
        "defaultpayLabel": "Chce, aby to byla moja domyslna karta kredytowa.",
        "requiredLabel": "To pole należy obowiązkowo wypełnić.",
        "savepayLabel": "Zapisz te karte kredytowa w moim osobistym profilu.",
        "saveAsPrimaryCardText": "Chce, aby to byla moja domyslna karta kredytowa."
    },
    "pt": {
        "paymentCardholderNameLabel": "Nome: (como mencionado no cartão de crédito)",
        "ibanAccountHolderNameLabel": "Account Holder",
        "ibanLabel": "IBAN",
        "cardholderNameError": "Este campo poderá conter somente caracteres A-Z, 0-9.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Número do Cartão de Crédito",
        "bankCountryLabel": "Country",
        "monthLabel": "Mês",
        "yearLabel": "Ano",
        "defaultpayLabel": "Marcar este cartão como cartão de crédito padrão.",
        "requiredLabel": "Campo é obrigatório",
        "savepayLabel": "Salve o cartão de crédito para a Minha Conta",
        "saveAsPrimaryCardText": "Marcar este cartão como cartão de crédito padrão."
    },
    "ro": {
        "paymentCardholderNameLabel": "Nume: (precum apare pe cartea de credit)",
        "cardholderNameError": "Acest câmp poate conţine doar caractere A-Z, 0-9.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Numărul cărţii de credit",
        "monthLabel": "Luna",
        "yearLabel": "An",
        "defaultpayLabel": "Selecteaza drept cartea mea de credit implicita.",
        "requiredLabel": "Acest câmp este obligatoriu.",
        "savepayLabel": "Salvarea acestei cărţi de credit în profilul meu personal.",
        "saveAsPrimaryCardText": "Selecteaza drept cartea mea de credit implicita."
    },
    "ru": {
        "paymentCardholderNameLabel": "Имя Фамилия: (как указано на Кредитной Карте)",
        "cardholderNameError": "Это поле может содержать только буквы A-Z или цифры 0-9.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Номер Кредитной Карты",
        "monthLabel": "Месяц",
        "yearLabel": "Год",
        "defaultpayLabel": "Использовать эту Кредитную Карту для оплаты по умолчанию.",
        "requiredLabel": "Это поле обязательно для заполнения.",
        "savepayLabel": "Сохранить эту кредитную карту для моего счета",
        "saveAsPrimaryCardText": "Использовать эту Кредитную Карту для оплаты по умолчанию."
    },
    "sk": {
        "paymentCardholderNameLabel": "Meno: (ako je zobrazené na kreditnej karte)",
        "cardholderNameError": "Toto pole môže obsahovať iba znaky A-Z, 0-9.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Císlo kreditnej karty",
        "monthLabel": "Mesiac",
        "yearLabel": "Rok",
        "defaultpayLabel": "Nastav ako moju primárnu kreditnú kartu",
        "requiredLabel": "Je potrebné vyplniť toto pole.",
        "savepayLabel": "Uložiť kreditnú kartu do môjho profilu",
        "saveAsPrimaryCardText": "Nastav ako moju primárnu kreditnú kartu"
    },
    "sv": {
        "paymentCardholderNameLabel": "Namn: (enligt kreditkort)",
        "cardholderNameError": "Detta fält kan bara innehålla romerska tecken (IV, V, X).",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Kreditkortnummer",
        "monthLabel": "Månad",
        "yearLabel": "År",
        "defaultpayLabel": "Gör detta till mitt huvudsakliga kreditkort.",
        "requiredLabel": "Detta fält måste ifyllas.",
        "savepayLabel": "Spara mina kreditkortsuppgifter.",
        "saveAsPrimaryCardText": "Gör detta till mitt huvudsakliga kreditkort."
    },
    "sv_SE": {
        "savepayLabel": "Spara detta kreditkortet på min personliga profil."
    },
    "th": {
        "paymentCardholderNameLabel": "ชื่อผู้รับ: (ตามที่ปรากฎบนบัตรเครดิต)",
        "cardholderNameError": "ส่วนนี้ให้เลือกเป็นตัวเลข 0-9 เท่านั้น",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "เลขที่บัตรเครดิต",
        "monthLabel": "เดือน",
        "yearLabel": "ปี",
        "defaultpayLabel": "ทำให้เป็นบัตรเครดิตเริ่มต้นของฉัน.",
        "requiredLabel": "กรุณากรอกข้อมูลนี้ให้ครบถ้วน",
        "savepayLabel": "บันทึกข้อมูลบัตรเครดิตนี้ในแฟ้มประวัติของฉัน.",
        "saveAsPrimaryCardText": "ทำให้เป็นบัตรเครดิตเริ่มต้นของฉัน."
    },
    "th_SE": {
        "cardholderNameError": "ช่องนี้จะกรอกได้เฉพาะอักขระ A-Z และ 0-9 เท่านั้น",
        "requiredLabel": "จำเป็นต้องกรอกช่องนี้"
    },
    "th_TH": {
        "ccNumberLabel": "หมายเลขบัตรเครดิต"
    },
    "tr": {
        "paymentCardholderNameLabel": "Isim: (kredi kartının üzerinde görüldüğü gibi)",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Kredi Karti Numarasi",
        "monthLabel": "Ay",
        "yearLabel": "Yıl",
        "defaultpayLabel": "Bu kartı kaydet.",
        "requiredLabel": "Bu alanı doldurmak zorunludur.",
        "savepayLabel": "Bu kredi kartı kişisel bilgilerimde saklansın",
        "saveAsPrimaryCardText": "Bu kartı kaydet."
    },
    "uk": {
        "paymentCardholderNameLabel": "Ім'я Прізвище: (як зазначено на Кредитній Карті)",
        "cardholderNameError": "Це поле може містити тільки літери AZ або цифри 0-9.",
        "cardholderNameRegex": /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Номер Кредитної Картки",
        "monthLabel": "Місяць",
        "yearLabel": "Рік",
        "defaultpayLabel": "Використовувати цю Кредитну Картку для оплати за замовчуванням.",
        "requiredLabel": "Це поле є обов язковим для заповнення.",
        "savepayLabel": "Зберегти цю кредитну карту для мого рахунку",
        "saveAsPrimaryCardText": "Використовувати цю Кредитну Картку для оплати за замовчуванням."
    },
    "vi": {
        "paymentCardholderNameLabel": "Tên: (Như nó xuất hiện trên thẻ tín dụng)",
        'cardholderNameMaxlength': '30',
        'cardholderNameRegex': /^[^$*&%#@0-9]{2,30}$/,
        "ccNumberLabel": "Số thẻ tín dụng",
        "monthLabel": "Tháng hết hạn",
        "yearLabel": "Năm hết hạn",
        "defaultpayLabel": "Lưu dưới dạng thẻ tín dụng chính",
        "requiredLabel": "Trường thông tin bắt buộc",
        "savepayLabel": "Ghi nhớ thông tin thẻ này ở tài khoản của tôi",
        "saveAsPrimaryCardText": "Lưu dưới dạng thẻ tín dụng chính"
    },
    'zh': {
        'paymentCardholderNameLabel': '姓名(如信用卡上显示的那样）',
        "ibanAccountHolderNameLabel": "銀行帳戶名",
        "ibanLabel": "國際銀行帳戶號碼(IBAN)",
        'paymentCardholderNamePlaceholder': '持卡人姓名',
        'cardholderNameError': '您输入的名称无效。',
        'cardholderNameMaxlength': '30',
        'cardholderNameRegex': /^[^$*&%#@0-9]{2,30}$/,
        'ccNumberLabel': '信用卡号',
        'ccNumberPlaceholder': '0000000000000000',
        'ccNumberError': '您输入的卡号无效。',
        'ccNumberMaxlength': '16',
        'ccNumberRegex': /^[0-9]{16}$/,
        "bankCountryLabel": "國家",
        'monthLabel': '到期月份',
        'yearLabel': '到期年份',
        'yearError': '您输入的年份无效',
        'defaultpayLabel': '另存为主要信用卡。',
        'savepayLabel': '将信用卡保存到我的帐户。',
        'requiredLabel': '这是必填栏。',
        'saveAsPrimaryCardText': '另存为主要信用卡'
    }
};
